import React, { useEffect, useRef, useState } from 'react';
import requestUtil from '../../../helpers/requestUtil';
import useConfiguration from '../../../hooks/useConfiguration';
import SimpleTable from '../../common/SimpleTable';
import DirectionMap from './directionMap';
import DistanceSummary from './distanceSummary';
const tableHeader = [
  {
    name: 'Shift Date',
    field: 'shiftStartDate',
    type: 'text',
    minWidth: 180,
  },
  {
    name: 'Name',
    field: 'name',
    type: 'text',
    minWidth: 120,
  },
  {
    name: 'Ratings',
    field: 'ratings',
    type: 'ratings',
    minWidth: 160,
  },
  {
    name: 'Phone',
    field: 'candidatePhone',
    type: 'text',
  },
  {
    name: 'Email',
    field: 'candidateEmail',
    type: 'text',
  },
  {
    name: 'City',
    field: 'candidateCity',
    type: 'text',
  },
  {
    name: 'State',
    field: 'candidateState',
    type: 'text',
  },
  {
    name: 'Zip',
    field: 'candidateZip',
    type: 'text',
  },
  {
    name: 'Message',
    field: 'message',
    type: 'icon',
  },
];
const patientHeader = [
 
  {
    name: 'Patient Name',
    field: 'patientName',
    type: 'text',
    minWidth: 120,
  },
   {
      name: 'Street Address',
      field: 'streetAddress',
      type: 'text',
      minWidth: 150
  },
  {
    name: 'Phone',
    field: 'phoneNumber',
    type: 'text',
  },
  {
    name: 'City',
    field: 'city',
    type: 'text',
  },
  {
    name: 'State',
    field: 'state',
    type: 'text',
  },
  {
    name: 'Zip',
    field: 'zipcode',
    type: 'text',
  },

];
// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  let refreshTimer = null;
  const distanceSummaryRef = useRef();
  const config = useConfiguration();
  const [gpsResult, setGpsResult] = useState({});
  const [errorMessage, setErrorMessage] = useState(undefined);
  const [shiftDetails, setShiftDetails] = useState({});
  const [patientDetails,setPatientDetails] = useState({})

  const generateRowData = () => {
    const rowData = [];
    const columns = [];
    columns.push({
      type: 'text',
      data: shiftDetails.jobDate,
    });
    columns.push({
      type: 'text',
      data: `${props.candidateFirstName} ${props.candidateLastName}`,
    });
    columns.push({
      type: 'ratings',
      data: props.ratings,
    });
    rowData.push({
      columns,
    });
    return rowData;
  };
  const generatePatientRowData =  () => {
    const rowData = [];
    const columns = [];
    // columns.push({
    //     type: 'text',
    //     data: shiftDetails.jobDate
    // });
    columns.push({
      type: 'text',
      data: patientDetails?.patientName,
    });
    columns.push({
      type: 'text',
      data: patientDetails?.streetAddress,
    });
    columns.push({
      type: 'text',
      data: patientDetails?.phoneNumber,
    });
    // columns.push({
    //   type: 'text',
    //   data: shiftDetails?.candidateInfo?.email,
    // });
    columns.push({
      type: 'text',
      data: patientDetails?.city,
    });
    columns.push({
      type: 'text',
      data: patientDetails?.state,
    });
    columns.push({
      type: 'text',
      data: patientDetails?.zipcode,
    });
    columns.push({
      type: 'text',
      data: '',
    });
    rowData.push({
      columns,
    });
    return rowData;
  };
  const refreshGpsData = (jobId, candidateId, gpsDataId) => {
    if (candidateId === '') {
      candidateId = null;
    }
    requestUtil(
      `${config.baseUrl}/Employers/get-candidates-gps-list`,
      'POST',
      {
        jobUniqueId: jobId,
        candidateUniqueId: candidateId,
        candidatesGpsDataId: gpsDataId || undefined,
        jobsClaimId:(parseInt(props.gpsCurrentTrackingStatus) >= 1 && parseInt(props.gpsCurrentTrackingStatus) <=3 ) ? props.jobsClaimId ? props.jobsClaimId  : 0 : 0
      }
    )
      .then((result) => {
        const gpsFields = result?.gpsFields;
        const getPatientFields = result?.patientGPSFields;
        setGpsResult(gpsFields[gpsFields.length - 1]);
        if((parseInt(props?.shiftType) === 2)){
          setPatientDetails(getPatientFields)
        }
        if (!refreshTimer) {
          refreshTimer = setInterval(() => {
            refreshGpsData(
              jobId,
              candidateId,
              gpsFields[gpsFields.length - 1]?.candidatesGpsDataId
            );
          }, 15000);
        }
      })
      .catch((err) => {
        setErrorMessage(err.message);
      });
  };
  const stopRefresh = () => {
    if (refreshTimer) {
      clearInterval(refreshTimer);
      refreshTimer = null;
    }
  };
  const mapDataReady = () => {
    return (
      gpsResult?.latitude &&
      gpsResult?.longtitude &&
      (parseInt(props?.shiftType) !== 2) ? props?.locationInfo?.latitude:patientDetails?.latitude &&
      (parseInt(props?.shiftType) !== 2) ? props?.locationInfo?.longitude:patientDetails?.longtitude
    );
  };
  useEffect(() => {
    if (config.baseUrl && (props.jobShiftUniqueId ||props.jobsShiftUniqueId)  ) {
      requestUtil(`${config.baseUrl}/Employers/getshiftdetails/${props.jobShiftUniqueId || props.jobsShiftUniqueId}/${props.jobsClaimId ? props.jobsClaimId : 0}`, 'GET').then(result => {
        setShiftDetails(result);
      })
        .catch((err) => {
          setErrorMessage(err.message);
        });
      stopRefresh();
      refreshGpsData(props.jobUniqueId, props.candidateUniqueId);
    }
    return () => {
      stopRefresh();
    };
  }, [props, config]);
  //   useEffect(() => {
  //     return () => {
  //       stopRefresh();
  //     };
  //   }, []);
  const updateDistanceData = (distance) => {
    distanceSummaryRef.current.updateDistanceData(distance);
  };
  return (
    <div>
      {errorMessage && (
        <>
          <div
            className="toast wrap-input100 align-items-center text-white bg-danger border-0 show"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            data-bs-autohide="false"
          >
            <div className="d-flex col-6">
              <div className="toast-body">
                {errorMessage || 'GPS error! Please try again.'}
              </div>
            </div>
          </div>
          <div>&nbsp;</div>
        </>
      )}
      <SimpleTable headers={tableHeader} rows={generateRowData()} />
      {(parseInt(props?.shiftType) === 2) ? <SimpleTable headers={patientHeader} rows={generatePatientRowData()} />:""} 
      <DistanceSummary ref={distanceSummaryRef} />
      {mapDataReady() && (
        <DirectionMap
          apiKey={config.directionAPIKey}
          from={{
            lat: parseFloat(gpsResult?.latitude),
            lng: parseFloat(gpsResult?.longtitude),
          }}
          to={{
            lat: parseFloat((parseInt(props?.shiftType) !== 2) ? props?.locationInfo?.latitude:patientDetails?.latitude),
            lng: parseFloat((parseInt(props?.shiftType) !== 2) ? props?.locationInfo?.longitude:patientDetails?.longtitude),
          }}
          updateDistanceData={updateDistanceData}
        />
      )}
    </div>
  );
};
